'use client';

import { atom } from 'jotai';

interface FormErrors {
  [key: string]: string | null;
}
export const formErrorsAtom = atom<FormErrors>({} as FormErrors);
